export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00356.2e24958d.png";